const ReportIcon = svgProps => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="report-icon"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69843 10.2815C4.95834 10.2815 5.9797 9.2601 5.9797 8.00019C5.9797 6.74028 4.95834 5.71892 3.69843 5.71892C2.43852 5.71892 1.41716 6.74028 1.41716 8.00019C1.41716 9.2601 2.43852 10.2815 3.69843 10.2815ZM3.69843 11.6986C5.74102 11.6986 7.39686 10.0428 7.39686 8.00019C7.39686 5.9576 5.74102 4.30176 3.69843 4.30176C1.65584 4.30176 0 5.9576 0 8.00019C0 10.0428 1.65584 11.6986 3.69843 11.6986Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3011 10.2815C13.561 10.2815 14.5823 9.2601 14.5823 8.00019C14.5823 6.74028 13.561 5.71892 12.3011 5.71892C11.0411 5.71892 10.0198 6.74028 10.0198 8.00019C10.0198 9.2601 11.0411 10.2815 12.3011 10.2815ZM12.3011 11.6986C14.3436 11.6986 15.9995 10.0428 15.9995 8.00019C15.9995 5.9576 14.3436 4.30176 12.3011 4.30176C10.2585 4.30176 8.60263 5.9576 8.60263 8.00019C8.60263 10.0428 10.2585 11.6986 12.3011 11.6986Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.123171 4.31352L3.77217 4.31305L3.77236 5.73021L0.123355 5.73069L0.123171 4.31352Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2286 4.3156L15.8776 4.31512L15.8778 5.73229L12.2288 5.73276L12.2286 4.3156Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.93299 5.45424L10.0705 5.49627L10.0561 6.91336L5.91859 6.87133L5.93299 5.45424Z"
      fill="currentColor"
    />
  </svg>
)

export default ReportIcon
